import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

const ItemsSelect = props => {

    const { items, selectLabel, selectOnChange, selectInputValue, selectInputDefaultOption } = props;
    let itemsArray = items ? items : [];
    
    return (
        <FormGroup style={{ display: 'flex', alignItems: 'center', paddingLeft: 20 }}>
            <Label>{selectLabel}</Label>
            <Input
                type='select'
                name='itemValue'
                onChange={selectOnChange}
                value={selectInputValue}
                style={{ maxWidth: 200, marginLeft: 30 }}
            >
                <option selected={true} disabled={true} value=''>{selectInputDefaultOption}</option>
                {
                    itemsArray.map((item, i) => {

                        return <option
                            key={`${item.value}_${i}`}
                            id={item.id}
                            value={item.value}
                            data-template={item.template}>
                            {item.value}
                        </option>
                    })
                }
            </Input>
        </FormGroup>
    );
}

export default ItemsSelect;


// WEBPACK FOOTER //
// ./src/components/common/stringTemplateRenderer/ItemsSelect.js